import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { renderHTMLString, siteTypesEnum } from '../../../../helpers';

import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import PersonHeader from '../../../sections/PersonHeader/PersonHeader';
import PersonContent from '../../../sections/PersonContent/PersonContent';
import PersonFooter from '../../../sections/PersonFooter/PersonFooter';
import PersonContentTable from '../../../sections/PersonContent/PersonContentTable/PersonContentTable';
import PersonContentList from '../../../sections/PersonContent/PersonContentList/PersonContentList';
import PersonContentCarousel from '../../../sections/PersonContent/PersonContentCarousel/PersonContentCarousel';
import PersonSocialLinks from '../../../sections/PersonContent/PersonSocialLinks/PersonSocialLinks';

export function SpeakerDetailsView(props) {
  const {
    siteHeader: { data: { title } = {}, meta: { title: siteTitle } = {} } = {},
    siteSpeakerDetails: {
      data: {
        forename = '',
        surname = '',
        bio: profile = '',
        relatedSessions = [],
        relatedSpeakers = [],
        contacts: { linkedIn, twitter, facebook, url } = {},
        contacts,
        showFooter,
      } = {},
      data = {},
      meta: { title: metaTitle } = {},
    } = {},
    pageConfig: { siteType } = {},
    t,
    i18n: { language } = {},
    match: { params: { speakerPath } = {} } = {},
  } = props;

  const { COURSE } = siteTypesEnum();
  const speakerType =
    siteType === COURSE ? t('event.trainer') : t('event.speaker');
  const shownPersonContentSection =
    siteType !== COURSE &&
    (relatedSessions.length > 0 || relatedSpeakers.length > 0);
  const shownPersonSocialLinks = linkedIn || twitter || facebook || url;
  const helmet = {
    title: `${metaTitle} | ${siteTitle} ${speakerType}`,
    og: {
      description: `${speakerType} profile for ${forename} ${surname}`,
    },
  };

  return (
    <SiteLayout helmet={helmet}>
      <PersonHeader data={data} look="speaker" />
      <PersonContent>
        {profile && (
          <div
            className={`c-person-content-section__column col-xs-12 ${
              siteType === COURSE ? 'col-sm-12' : 'col-sm-7'
            }`}
          >
            <PersonContentTable header={t('event.speaker.profile')}>
              <div className="c-person-content-section__container">
                {renderHTMLString(profile)}
              </div>
            </PersonContentTable>
            {shownPersonSocialLinks && (
              <PersonContentTable
                header={t('event.speaker.network', {
                  0: `${forename} ${surname}`,
                })}
              >
                <PersonSocialLinks contacts={contacts} hideEmail />
              </PersonContentTable>
            )}
          </div>
        )}
        {shownPersonContentSection && (
          <div className="c-person-content-section__column col-xs-12 col-sm-5">
            {relatedSessions.length > 0 && (
              <PersonContentTable header={t('event.speaker.agenda-sessions')}>
                <PersonContentList list={relatedSessions} locale={language} />
              </PersonContentTable>
            )}
            {relatedSpeakers.length > 1 && (
              <PersonContentTable
                header={t(`event.at-this-${siteType.toLowerCase()}`)}
              >
                <PersonContentCarousel
                  slides={relatedSpeakers}
                  currentPersonPath={speakerPath}
                />
              </PersonContentTable>
            )}
          </div>
        )}
      </PersonContent>
      {showFooter && (
        <PersonFooter
          title={t('event.speaker.see-them-speak', {
            0: forename,
            1: title,
          })}
          isCourse={siteType === COURSE}
          showFooter={showFooter}
        />
      )}
    </SiteLayout>
  );
}

SpeakerDetailsView.propTypes = {
  siteHeader: PropTypes.object,
  siteSpeakerDetails: PropTypes.object,
  pageConfig: PropTypes.object,
  match: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
    siteSpeakerDetails: state.siteSpeakerDetails,
    pageConfig: state.pageConfig,
  };
}

export default withTranslation()(
  connect(mapStateToProps)(withRouter(SpeakerDetailsView)),
);
